import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

const identityServer    = environment.identityServer;
const authHeaderClient  = environment.authHeaderClient;

@Injectable()
export class AuthenticationService {

  constructor(private client: HttpClient) { }
  attemptAuth(ussername: string, password: string): Observable<string> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': authHeaderClient
      })
    };
    const credentials = `username=${ussername}&password=${password}&grant_type=password`;
    return this.client.post<string>(`${identityServer}/connect/token`, credentials, httpOptions);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth/authentication.service.ts